import * as React from 'react';

import {Card} from 'shells/card/card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import {InvoiceDetails} from './invoice-details';

export type EstimatedInvoice = {
    __typename: 'BillingInvoice';
    id: string;
    amount: string;
    date: number;
};

type Props = {
    nextEstimatedInvoice: EstimatedInvoice | null | undefined;
    lastThreeInvoices: EstimatedInvoice[] | null | undefined;
    isLoading: boolean;
};

export function NextEstimatedInvoice(props: Props) {
    return (
        <Card hasBorder={true} fitHeight={true}>
            <div className='pad-16'>
                <StackLegacy spacing={16}>
                    <StackLegacy spacing={8}>
                        <UppercaseLabel>Next estimated invoice</UppercaseLabel>
                        {props.isLoading ? (
                            <LoadingPage />
                        ) : (
                            <>
                                <InvoiceDetails
                                    nextEstimatedInvoice={props.nextEstimatedInvoice}
                                    lastThreeInvoices={props.lastThreeInvoices}
                                />
                            </>
                        )}
                    </StackLegacy>
                </StackLegacy>
            </div>
        </Card>
    );
}
